/* 
 * NGTVariableEvent.js
 * Created on 2-jan-2017
 * @author Swen Meeuwes for &ranj
 */

import VariableMutation from "/lib/html5-software-library/src/ranj/eng/content/VariableMutation";

export default class NGTVariableEvent {
    constructor(type, variable, value, operator) {
        this.type = type;
        this.variable = variable;
        this.value = value;
        this.operator = operator;
    }

    getCombinedString() {
        return `${this.variable} ${this._decodeOperator(this.operator)} ${this.value}`;
    }

    _decodeOperator(operator) {
        let operatorText = "=";
        switch (operator) {
            case VariableMutation.SET:
                operatorText = "=";
                break;
            case VariableMutation.ADD:
                operatorText = "+";
                break;
            case VariableMutation.SUBTRACT:
                operatorText = "-";
                break;
            case VariableMutation.MULTIPLY:
                operatorText = "*";
                break;
            case VariableMutation.DIVIDE:
                operatorText = "/";
                break;
        }
        return operatorText;
    }
}

NGTVariableEvent.VARIABLE_CHANGED = "NGTVariableEvent.VARIABLE_CHANGED";

